// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface OrchestraEndpointState
 */
export interface OrchestraEndpointState {
  /**
   * AWS VPC endpoint connection state as reported by the private-endpoint-operator.
   * @type {string}
   * @memberof OrchestraEndpointState
   */
  state?: string;
}

/**
 * Check if a given object implements the OrchestraEndpointState interface.
 */
export function instanceOfOrchestraEndpointState(
  value: object,
): value is OrchestraEndpointState {
  return true;
}

export function OrchestraEndpointStateFromJSON(
  json: any,
): OrchestraEndpointState {
  return OrchestraEndpointStateFromJSONTyped(json, false);
}

export function OrchestraEndpointStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OrchestraEndpointState {
  if (json == null) {
    return json;
  }
  return {
    state: json['state'] == null ? undefined : json['state'],
  };
}

export function OrchestraEndpointStateToJSON(
  json: any,
): OrchestraEndpointState {
  return OrchestraEndpointStateToJSONTyped(json, false);
}

export function OrchestraEndpointStateToJSONTyped(
  value?: OrchestraEndpointState | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    state: value['state'],
  };
}
